import { useContext } from "react";
import { AppContext } from "contexts/AppContext";
import SectionWrapper from "components/layouts/SectionWrapper";
import { Box, Skeleton } from "@mui/material";
import Headline6 from "components/elements/Headline6";
import { useNavigate } from "react-router-dom";
import Headline3 from "components/elements/Headline3";
import ContentNormal from "components/elements/ContentNormal";
import { replaceBrandDataPlaceholders } from "./util";
import ButtonMedium4 from "components/elements/ButtonMedium4";

const FrontPageCustomSection = (props) => {
    const navigate = useNavigate()
    const { styleGuide, brandData } = useContext(AppContext)

    const onButtonClick = () => {
        if(props.section.buttonLink.startsWith('http')) {
            window.open(props.section.buttonLink, "_blank")
        } else {
            navigate(props.section.buttonLink)
        }
    }

    if(!props.section && !props.isLoading){
        return null
    }

    const bodyText = replaceBrandDataPlaceholders(brandData, props.section?.bodyText)

    return (
        <SectionWrapper backgroundColor={props.section?.backgroundColor}>
            <Box display={'flex'} alignItems={{xs: undefined, md: 'center'}} gap={4} flexDirection={{xs: 'column-reverse', md: props?.section?.imageAlignment === 'LEFT' ? 'row-reverse' : 'row'}}>
                <Box flex={1} display={'flex'} justifyContent={{xs: 'left', md: 'center'}} minWidth={320}>
                    {props.isLoading
                        ?
                            <Box flex={1} display={'flex'} flexDirection={'column'} maxWidth={{xs: undefined, md: 500}}>
                                <Skeleton variant="text" width={'60%'} />
                                <Skeleton variant="text" height={42} />
                                <Skeleton variant="text" width={'80%'} height={42} />
                            </Box>
                        :
                            <Box flex={1} display={'flex'} flexDirection={'column'} gap={2} maxWidth={{xs: undefined, md: 500}}>
                                <Box display={'flex'} flexDirection={'column'} gap={1}>
                                    <Headline6
                                        fallbackText={replaceBrandDataPlaceholders(brandData, props.section.category)}
                                        style={{ color: props.section?.textColor }}
                                    />
                                    <Headline3
                                        fallbackText={replaceBrandDataPlaceholders(brandData, props.section.title)}
                                        style={{ color: props.section?.textColor }}
                                    />
                                    {bodyText.split('\n').map((line, index) => (
                                        <ContentNormal
                                            key={index}
                                            fallbackText={line}
                                            style={{ color: props.section?.textColor }}
                                        />
                                    ))}
                                </Box>

                                {!!props.section.buttonText &&
                                    <Box>
                                        <ButtonMedium4
                                            fallbackText={props.section.buttonText}
                                            showIcon={false}
                                            onClick={() => onButtonClick()}
                                            style={{ backgroundColor: props.section?.buttonBackgroundColor, color: props.section?.buttonTextColor, borderColor: props.section?.buttonBackgroundColor }}
                                        />
                                    </Box>
                                }
                            </Box>
                    }
                </Box>

                <Box flex={1} display={'flex'} flexDirection={'column'} overflow={'hidden'} minWidth={320}>
                    { props.isLoading
                        ?
                            <Skeleton variant="rectangular" width={'100%'} height={{xs: 300,  md: 500}} />
                        :
                            <Box
                                flex={1}
                                style={{
                                    backgroundImage: `url(${props.section.imageUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundColor: styleGuide.color3,
                                    aspectRatio: 10/6,
                                }}
                            />
                    }
                </Box>
            </Box>
        </SectionWrapper>
    )
}

export default FrontPageCustomSection